<script setup lang="ts">
import { useTranslation } from 'i18next-vue';

import type { AppNotification } from '../types/notifications.types';
import NotificationRow from './NotificationRow.vue';

interface Props {
  notifications: AppNotification[];
  isLoading: boolean;
}

interface Emits {
  markAsRead: [id: string];
}

defineProps<Props>();
defineEmits<Emits>();

const { t } = useTranslation();
</script>

<template>
  <div class="notifications-drawer-body">
    <div v-if="isLoading" class="notifications-drawer-body__state">
      {{ t('common.loading') }}
    </div>
    <div v-else-if="notifications.length === 0" class="notifications-drawer-body__state">
      {{ t('nav.notifications_empty') }}
    </div>

    <div v-else class="notifications-drawer-body__list" role="list">
      <NotificationRow
        v-for="n in notifications"
        :key="n.id"
        :notification="n"
        @mark-as-read="$emit('markAsRead', $event)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.notifications-drawer-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notifications-drawer-body__list {
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.notifications-drawer-body__state {
  font-size: $text-sm;
  color: var(--p-surface-600);
  padding: $space-md $space-md $space-md $space-xl;
}
</style>
